import cn from 'classnames';
import { HTMLAttributes, Suspense } from 'react';

import { ILogoBanner } from './';

export function LogoBanner(props: ILogoBanner & HTMLAttributes<HTMLElement>) {
  const { className, logoData, ...rest } = props;

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div
        {...rest}
        className={cn(
          className,
          'flex flex-row flex-wrap justify-around md:justify-between gap-y-8',
        )}
      >
        {logoData.map((logo, idx) => {
          return (
            <div
              key={idx}
              className={cn('flex basis-1/3 md:basis-1/6 justify-center')}
            >
              <img
                className={cn('max-w-full m-2')}
                srcSet={logo.url}
                alt={logo.alt || ''}
                title={logo.title}
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
    </Suspense>
  );
}
